<template>
	<div class="d_date" :class="editable ? 'editable' : ''">
		<van-cell
			is-link
			:value="timeValue"
			@click="showPopup"
			:disabled="true"
		/>
			<van-popup v-model="show" position="bottom">
				<van-datetime-picker
					type="date"
					title='选择日期'
					v-model="currentDate"
					:loading="isLoadingShow"
					:formatter="formatter"
					@cancel="show = false"
					@confirm="confirmPicker"
				/>
				<!-- :min-date="minDate" --> 
				<!-- :max-date="maxDate" -->
				<!-- type="datetime" --> <!-- 年月日时分秒 -->
				<!-- type="date" --> <!-- 年月日 -->
			</van-popup>
		</van-cell>
	</div>
</template>

<script>
import { Cell, DatetimePicker  } from 'vant';

export default {
	components: {
		[Cell.name]: Cell, // 局部注册
		[DatetimePicker.name]: DatetimePicker,
	},
	props: {
    editable_type: {
      type: Boolean,
      default: ''
   },
  },
	data() {
		return {
			editable: this.editable_type,
			timeValue: '',
			show: false,
			isLoadingShow: true,
			currentDate: new Date(),
			// minDate: new Date(),
			// maxDate: new Date(2020, 12, 31),
		};
	},
  
	created() {
      this.getTime(); // 加载页面显示默认时间
   },
   methods: {
      // 显示弹窗
      showPopup () {
			if(this.editable){ return }
			this.show = true
			this.isLoadingShow = true
			setTimeout(() => {
				this.isLoadingShow = false
			}, 500)
      },
      // 确认选择之后的时间
      confirmPicker (val) {
        let year = val.getFullYear()
        let month = val.getMonth() + 1
        let day = val.getDate()
        let hour = val.getHours()
        let minute = val.getMinutes()
        // let second = val.getSeconds()
        if (month >= 1 && month <= 9) { month = `0${month}` }
        if (day >= 1 && day <= 9) { day = `0${day}` }
        if (hour >= 0 && hour <= 9) { hour = `0${hour}` }
        if (minute >= 0 && minute <= 9) { minute = `0${minute}` }
        // if (second >= 0 && second <= 9) { second = `0${second}` }
        // this.timeValue = `${year}-${month}-${day} ${hour}:${minute}:00`
		  this.timeValue = `${year}-${month}-${day}`
        console.log(this.timeValue)
		  this.$emit('save_time', this.timeValue)
        this.show = false
      },
      // 默认显示当前时间
      getTime () {
        let date = new Date()
        let y = date.getFullYear()
        let m = date.getMonth() + 1
        let d = date.getDate()
        let h = date.getHours()
        let min = date.getMinutes()
        // let s = date.getSeconds()
        if (m >= 1 && m <= 9) { m = `0${m}` }
        if (d >= 1 && d <= 9) { d = `0${d}` }
        if (h >= 0 && h <= 9) { h = `0${h}` }
        if (min >= 0 && min <= 9) { min = `0${min}` }
        // if (s >= 0 && s <= 9) { min = `0${s}` }
        // let time = `${y}-${m}-${d} ${h}:${min}:00`
		  let time = `${y}-${m}-${d}`
        this.timeValue = time
		  setTimeout(()=>{
			  this.$emit('save_time', this.timeValue)
		  },1000)
    },
      // 日期选项格式化函数
      formatter (type, value) {
        if (type === 'year') {
          return `${value}年`
        } else if (type === 'month') {
          return `${value}月`
        } else if (type === 'day') {
          return `${value}日`
        } else if (type === 'hour') {
          return `${value}时`
        } else if (type === 'minute') {
          return `${value}分`
        } else if (type === 'second') {
          return `${value}秒`
        }
        return value
      },
   }
};
</script>

<style lang='less' scoped>
.d_date{
	.van-cell {
		height: 40px;
		display: flex;
		align-items: center;
	   padding: 0px 8px;
	   font-size: 14px;
	   color: #000000;
	   background-color: #ffffff;
		border-radius: 4px;
	   border: 1px solid #DCDFE6;
	   box-sizing: border-box;
		opacity: 1;
	}
}
.editable{
	.van-cell {
		opacity: 0.99;
	}
}
</style>
